module.exports = __webpack_public_path__ + "img/mobile scanner stand29.93bba8d4.jpg";